module.exports = __webpack_public_path__ + "img/map1.c52f48be.jpg";